if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
            // Setup menu listeners when menu is opened
            if (this.menu) {
              this.setupMenuListeners();
            }
          }, 100);
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons - handle all summary elements including nested ones
      if (this.menu) {
        this.setupMenuListeners();
        
        // Also setup listeners when menu becomes visible/active
        const observer = new MutationObserver(() => {
          if (this.menu && this.toggle.classList.contains('active')) {
            this.setupMenuListeners();
          }
        });
        
        if (this.menu) {
          observer.observe(this.menu, { 
            childList: true, 
            subtree: true 
          });
        }
      }
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }

    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    setupMenuListeners() {
      if (!this.menu) return;
      
      // Setup listeners for all summary elements (including nested ones)
      // Use a data attribute to track if listener is already attached
      const allSummaries = this.menu.querySelectorAll('summary:not([data-listener-attached])');
      allSummaries.forEach(summary => {
        summary.setAttribute('data-listener-attached', 'true');
        summary.addEventListener('click', this.onSummaryClick.bind(this), true);
      });
      
      // Setup back buttons
      const allBackButtons = this.menu.querySelectorAll('.parent-link-back--button:not([data-listener-attached])');
      allBackButtons.forEach(button => {
        button.setAttribute('data-listener-attached', 'true');
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const linkForward = summaryElement.querySelector('.link-forward');
      const clickedElement = event.target;
      const parentLinkAnchor = summaryElement.querySelector('.parent-link-anchor');
      
      // Als er GEEN pijl (link-forward) is, dan is er geen submenu - navigeer gewoon
      if (!linkForward) {
        // Geen submenu, dus gewoon navigeren
        if (parentLinkAnchor) {
          event.preventDefault();
          event.stopPropagation();
          
          const linkUrl = parentLinkAnchor.getAttribute('href');
          if (linkUrl && linkUrl !== '#' && linkUrl !== '') {
            window.location.href = linkUrl;
          }
        }
        return false;
      }
      
      // Check if there's actually a submenu with real menu items (not just the back button)
      const subMenu = detailsElement.querySelector(':scope > .sub-menu');
      let hasSubmenu = false;
      if (subMenu) {
        // Check if there are actual menu items (li elements that are not the back button)
        // Filter out empty li elements and back buttons
        const allListItems = subMenu.querySelectorAll(':scope > li');
        const menuItems = Array.from(allListItems).filter(li => {
          // Skip back button
          if (li.classList.contains('parent-link-back')) return false;
          // Check if li has actual content (links, text, etc.)
          const hasLink = li.querySelector('a[href]') !== null;
          const hasContent = li.textContent.trim().length > 0;
          return hasLink || hasContent;
        });
        
        // Also check for nested submenus or mega menu content
        const hasNestedContent = subMenu.querySelector('.mega-menu-sidebar--content, .mega-menu-container, .mega-menu-promotion, .mega-menu-columns') !== null;
        
        hasSubmenu = menuItems.length > 0 || hasNestedContent;
      }
      
      // Als er GEEN echt submenu is (ook al is er een pijl), navigeer
      if (!hasSubmenu) {
        if (parentLinkAnchor) {
          event.preventDefault();
          event.stopPropagation();
          
          const linkUrl = parentLinkAnchor.getAttribute('href');
          if (linkUrl && linkUrl !== '#' && linkUrl !== '') {
            window.location.href = linkUrl;
          }
        }
        return false;
      }
      
      // Als er op de link zelf (anchor) wordt geklikt EN niet op de pijl, navigeer
      if (parentLinkAnchor && 
          (clickedElement === parentLinkAnchor || parentLinkAnchor.contains(clickedElement)) &&
          !linkForward?.contains(clickedElement) &&
          !clickedElement.closest('.link-forward')) {
        // Navigeer naar de link
        event.preventDefault();
        event.stopPropagation();
        
        const linkUrl = parentLinkAnchor.getAttribute('href');
        if (linkUrl && linkUrl !== '#' && linkUrl !== '') {
          window.location.href = linkUrl;
        }
        return false;
      }
      
      // Als er WEL een submenu is EN er wordt op de pijl of summary geklikt, open/sluit het submenu
      event.preventDefault();
      event.stopPropagation();
      
      const isOpen = detailsElement.hasAttribute('open');
      
      // Reset scroll for the current submenu container
      const subMenuContainer = detailsElement.closest('.mobile-menu-drawer, .sub-menu');
      if (subMenuContainer) {
        subMenuContainer.scrollTop = 0;
      }

      if (isOpen) {
        this.closeSubmenu(detailsElement);
      } else {
        // Set open attribute and class immediately for CSS to work
        detailsElement.setAttribute('open', '');
        // Add class immediately - CSS requires both [open] and .menu-opening
        detailsElement.classList.add('menu-opening');
        
        // Update listeners after a brief delay to ensure DOM is updated
        setTimeout(() => {
          this.setupMenuListeners();
        }, 50);
      }
      
      return false;
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      // Close all nested submenus first
      const nestedDetails = detailsElement.querySelectorAll('details[open]');
      nestedDetails.forEach(nested => {
        nested.classList.remove('menu-opening');
        nested.removeAttribute('open');
      });
      
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}